import { render, staticRenderFns } from "./DipReason.vue?vue&type=template&id=136ecb12&scoped=true"
import script from "./DipReason.vue?vue&type=script&lang=js"
export * from "./DipReason.vue?vue&type=script&lang=js"
import style0 from "./DipReason.vue?vue&type=style&index=0&id=136ecb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ecb12",
  null
  
)

export default component.exports